
import { Component, Vue } from "vue-property-decorator";
import Sidebar from "@/components/navigations/Sidebar.vue";
import Cta from "@/components/buttons/Button.vue";
import BenevoleService from "@/services/benevole.service";

interface SlackCandidate {
  id: string;
  username: string;
  nom_usage: string;
  picture: string;
  telephone: string | null;
}

@Component({
  components: { Sidebar, Cta },
})
/** Admin form to onboard a new volunteer, either freeform or picked from unregistered Slack workspace members. */
export default class BenevoleCreate extends Vue {
  dataReady = false;
  candidates: SlackCandidate[] = [];
  selectedUser: SlackCandidate | null = null;
  search = "";

  prenom = "";
  nom = "";
  nom_usage = "";
  slack_id = "";
  telephone = "";

  async mounted(): Promise<void> {
    const raw = await BenevoleService.canAddFromSlack();
    this.candidates = raw;
    this.dataReady = true;
  }

  /** Slack candidates matching the search box, by display name or username. */
  get filteredCandidates(): SlackCandidate[] {
    if (!this.search.trim()) return this.candidates;
    const q = this.search.toLowerCase();
    return this.candidates.filter(
      (u) =>
        u.nom_usage.toLowerCase().includes(q) ||
        u.username.toLowerCase().includes(q)
    );
  }

  /** Auto-generated username: first letter of first name + last name, accents/hyphens stripped. */
  get username(): string {
    const normalize = (s: string) =>
      s
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^a-zA-Z]/g, "")
        .toLowerCase();
    const p = normalize(this.prenom);
    const n = normalize(this.nom);
    if (!p && !n) return "";
    return p.charAt(0) + n;
  }

  get isValid(): boolean {
    return !!(
      this.prenom &&
      this.nom &&
      this.nom_usage &&
      this.username &&
      this.slack_id
    );
  }

  /** Pre-fills the form from a picked Slack candidate. */
  selectUser(user: SlackCandidate): void {
    this.selectedUser = user;
    this.slack_id = user.id;
    this.nom_usage = user.nom_usage;
    this.telephone = user.telephone ?? "";
  }

  /** Submits the new volunteer, then navigates to their detail page. */
  private async create(): Promise<void> {
    const id = await BenevoleService.create({
      prenom: this.prenom,
      nom: this.nom,
      nom_usage: this.nom_usage,
      username: this.username,
      slack_id: this.slack_id,
      telephone: this.telephone,
    });
    if (id) {
      this.$router.push(`/administration/benevole/${id}`);
    }
  }
}
